import { useState, useEffect } from "react";

const readWindowSize = () => ({
  width: typeof window !== "undefined" ? window.innerWidth : undefined,
  height: typeof window !== "undefined" ? window.innerHeight : undefined,
});

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(readWindowSize);

  useEffect(() => {
    let frame = 0;

    const handleResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        setWindowSize(readWindowSize());
      });
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return windowSize;
};

export default useWindowSize;
